<script lang="ts">
	import { ProjectorPreferencesManager } from "../../../ProjectorPreferenceManager.svelte"
	import { ToggleSwitch } from "misc-ui"

	let audioOnly = $derived(
		ProjectorPreferencesManager.pendingChanges.audioOnly ??
			ProjectorPreferencesManager.preferences.audioOnly ??
			false
	)

	function onToggle() {
		ProjectorPreferencesManager.stageChange("audioOnly", !audioOnly)
	}
</script>

<div class="flex-row switch-container">
	<span class="label">Audio-Only Mode: </span>
	<ToggleSwitch
		info="This device is to be treated as audio-only. (It ignores projector control auto-detection)"
		isEnabled={audioOnly}
		onUpdate={onToggle}
	/>
</div>
